export const actionTypes = {
  FETCH_MEMBERSHIP_SUCCESS: 'MEMBER_PORTAL/FETCH_MEMBERSHIP_SUCCESS',
  FETCH_MEMBERSHIP_LOADING: 'MEMBER_PORTAL/FETCH_MEMBERSHIP_LOADING',
  RESET_MEMBERSHIP: 'MEMBER_PORTAL/RESET_MEMBERSHIP',
};
